<template>
  <main class="page-shell">
    <div class="stat-grid two" v-if="me">
      <div class="stat-card">
        <div class="label">当前余额</div>
        <div class="value" :style="{ color: Number(me.balance) > 0 ? 'var(--green)' : 'var(--red)' }">
          {{ formatMoney(me.balance) }} 元
        </div>
      </div>
      <div class="stat-card">
        <div class="label">当前花费</div>
        <div class="value" :style="{ color: 'var(--red)' }">
          {{ formatMoney(stats.totalCost) }} 元
        </div>
      </div>
      <div class="stat-card">
        <div class="label">总量</div>
        <div class="value">{{ formatTokens(Number(stats.totalTokens)) }}</div>
      </div>
      <div class="stat-card">
        <div class="label">状态</div>
        <div class="value" style="font-size: 16px">
          <el-tag :type="me.status === 'active' ? 'success' : 'danger'">
            {{ me.status === 'active' ? '可用' : '已停用' }}
          </el-tag>
        </div>
      </div>
    </div>

    <section class="soft-card tabs-panel section-gap" v-if="me">
      <el-tabs v-model="tab">
        <!-- 调用记录 -->
        <el-tab-pane label="调用记录" name="usage">
          <div class="toolbar">
            <span class="muted-text" v-if="lastRefresh">每 60 秒自动刷新 · 上次 {{ lastRefresh }}</span>
            <div class="toolbar-spacer"></div>
            <el-button size="small" icon="el-icon-refresh" :loading="usageLoading" @click="manualRefreshUsage">刷新</el-button>
          </div>
          <el-table :data="usageList" v-loading="usageLoading">
            <el-table-column prop="modelName" label="模型" />
            <el-table-column label="输入Token" align="right">
              <template slot-scope="s">{{ formatTokens(s.row.inputTokens) }}</template>
            </el-table-column>
            <el-table-column label="缓存Token" align="right">
              <template slot-scope="s">{{ formatTokens(s.row.cacheTokens) }}</template>
            </el-table-column>
            <el-table-column label="输出Token" align="right">
              <template slot-scope="s">{{ formatTokens(s.row.outputTokens) }}</template>
            </el-table-column>
            <el-table-column label="总Token" align="right">
              <template slot-scope="s">{{ formatTokens(s.row.totalTokens) }}</template>
            </el-table-column>
            <el-table-column label="费用(元)" align="right">
              <template slot-scope="s">{{ formatMoney(s.row.totalCost) }}</template>
            </el-table-column>
            <el-table-column label="时间">
              <template slot-scope="s">{{ formatTime(s.row.requestStartAt || s.row.createdAt) }}</template>
            </el-table-column>
          </el-table>
          <el-pagination class="pagination-bar" layout="total, prev, pager, next" :total="usageTotal"
                         :page-size="usageSize" :current-page.sync="usagePage" @current-change="loadUsage" small />
        </el-tab-pane>

        <!-- 可用模型 -->
        <el-tab-pane label="可用模型" name="models">
          <el-table :data="models" v-loading="modelsLoading">
            <el-table-column prop="modelName" label="模型名称" />
            <el-table-column prop="inputPrice" label="输入价(元/1K)" align="right" />
            <el-table-column prop="outputPrice" label="输出价(元/1K)" align="right" />
            <el-table-column prop="cachePrice" label="缓存价(元/1K)" align="right" />
          </el-table>
        </el-tab-pane>

        <!-- 充值记录 -->
        <el-tab-pane label="充值记录" name="recharge">
          <el-table :data="balanceList" v-loading="balanceLoading">
            <el-table-column label="充值金额(元)" align="right">
              <template slot-scope="s">
                <span style="color: var(--green)">{{ formatMoney(s.row.amount) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="afterBalance" label="充值后余额" align="right" />
            <el-table-column prop="remark" label="备注" />
            <el-table-column label="时间">
              <template slot-scope="s">{{ formatTime(s.row.createdAt) }}</template>
            </el-table-column>
          </el-table>
          <el-pagination class="pagination-bar" layout="total, prev, pager, next" :total="balanceTotal"
                         :page-size="balanceSize" :current-page.sync="balancePage" @current-change="loadBalanceLogs" small />
        </el-tab-pane>
      </el-tabs>
    </section>
  </main>
</template>

<script>
import { formatMoney, formatTime, formatTokens } from '@/utils/format'

export default {
  name: 'UserProfile',
  data() {
    return {
      me: null,
      stats: { totalCost: 0, totalTokens: 0 },
      tab: 'usage',
      models: [],
      modelsLoading: false,
      usageList: [],
      usageTotal: 0,
      usagePage: 1,
      usageSize: 10,
      usageLoading: false,
      lastRefresh: '',
      refreshTimer: null,
      balanceList: [],
      balanceTotal: 0,
      balancePage: 1,
      balanceSize: 10,
      balanceLoading: false
    }
  },
  created() {
    this.loadMe()
    this.loadStats()
    this.loadModels()
    this.loadUsage(true)
    this.loadBalanceLogs()
    this.refreshTimer = setInterval(() => {
      this.loadUsage()
      this.loadStats()
    }, 60000)
  },
  beforeDestroy() {
    if (this.refreshTimer) clearInterval(this.refreshTimer)
  },
  methods: {
    formatMoney,
    formatTime,
    formatTokens,
    async loadMe() {
      const res = await this.$http.get('/user/me')
      if (res.code === 200) this.me = res.data
    },
    async loadStats() {
      try {
        const res = await this.$http.get('/user/stats')
        if (res.code === 200) this.stats = res.data
      } catch (e) {
      }
    },
    async loadModels() {
      this.modelsLoading = true
      try {
        const res = await this.$http.get('/user/models')
        if (res.code === 200) this.models = res.data
      } catch (e) {
      } finally {
        this.modelsLoading = false
      }
    },
    async loadUsage(silent) {
      this.usageLoading = true
      try {
        const res = await this.$http.get('/user/usage', { params: { page: this.usagePage, size: this.usageSize } })
        if (res.code === 200) {
          this.usageList = res.data.list
          this.usageTotal = res.data.total
        }
      } catch (e) {
      } finally {
        this.usageLoading = false
      }
      if (!silent) this.lastRefresh = formatTime(Date.now())
    },
    manualRefreshUsage() {
      this.loadUsage()
    },
    async loadBalanceLogs() {
      this.balanceLoading = true
      try {
        const res = await this.$http.get('/user/balance-logs', { params: { page: this.balancePage, size: this.balanceSize } })
        if (res.code === 200) {
          this.balanceList = res.data.list
          this.balanceTotal = res.data.total
        }
      } catch (e) {
      } finally {
        this.balanceLoading = false
      }
    }
  }
}
</script>

<style scoped>
.section-gap {
  margin-top: 16px;
}
</style>